import { routeUrls as routeUrl } from '../RouteUrls';
import { LegacyWorkPath } from '../../../pages/LegacyWorkPath';
import { WorkPrintPage } from '../../../pages/WorkPrintPage';
import { OpenFilePage } from '../../../pages/OpenFilePage';

export function LegacyRoutes() {
  return [
    { path: routeUrl.legacyWork.path, Component: LegacyWorkPath },
    { path: routeUrl.legacyWorkPrint.path, Component: WorkPrintPage },
    { path: routeUrl.legacyOpenFile.path, Component: OpenFilePage },
  ];
}
